export const getStatusLabel = (enabled: boolean) =>
  enabled ? 'Enabled' : 'Disabled';
